import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import AddBulkLabItems from './AddBulkLabItems';
import BulkUpdateSKUPrice from './BulkUpdateSKUPrice';

import { Popover, PopoverTitle, PopoverItem, Button, ButtonWithLoader, PopoverBody } from '../../../Styles';
import { AddIcon, ProcessingIcon } from '../../../Styles';

import { setUploadInventoryFileAction, setUploadInventoryFileBatch, fetchUploadInventoryFileBatch } from '../../../../actions/inventoryActionsV2';
import { checkLabSeller } from '../../../../commons/utils';

import { SPJ_ACTIONS, BULK_FILE_UPLOAD_STAGES } from '../../../../commons/utils';

const BulkOperations = ({ refreshing = false, refresh, ...props }) => {
	const [anchorElement, setAnchorElement] = useState(null);
	const [fetchingBatches, setFetchingBatches] = useState(false);
	const [operation, setOperation] = useState(null);

	const {
		inventory,
		showUploadInventoryFile,
		disableBulkUploadInventoryCreate,
		disableBulkUploadInventoryUpdate,
		disableBulkUploadInventoryDelete,
		disableBulkUploadPrice,
		setUploadInventoryFileAction,
		setUploadInventoryFileBatch,
		fetchUploadInventoryFileBatch,
	} = props;
	const { count } = inventory;

	const LabActions = [{ value: SPJ_ACTIONS.LAB_INVENTORY_CREATE, name: 'Add Items', disabled: showUploadInventoryFile },
		{ value: SPJ_ACTIONS.LAB_SKU_PRICE_UPDATE, name: 'Bulk Update SKU Price', disabled: showUploadInventoryFile }
	];

	const ProcurementActions = [
		{ value: SPJ_ACTIONS.INVENTORY_CREATE, name: 'Add Items', disabled: showUploadInventoryFile },
		{ value: SPJ_ACTIONS.INVENTORY_UPDATE, name: 'Update Items', disabled: count === 0 || showUploadInventoryFile },
		{ value: SPJ_ACTIONS.PRICE_UPDATE, name: 'Update Bucket Prices', disabled: count === 0 || showUploadInventoryFile },
	];

	const { isLabSeller } = props;
	let options = ProcurementActions;
	if (isLabSeller) {
		options = LabActions;
	}

	const fetchBatches = async () => {
		setUploadInventoryFileAction(false);
		setUploadInventoryFileBatch('');

		setFetchingBatches(true);
		await fetchUploadInventoryFileBatch();
		setFetchingBatches(false);
	};

	const openInventoryFileUpload = () => {
		const { uploadInventoryFileType } = props;
		if (options.map((option) => option.value).includes(uploadInventoryFileType)) {
			setOperation(uploadInventoryFileType);
		}
	};

	useEffect(() => {
		if (refreshing) {
			fetchBatches();
		}
	}, [refreshing]);

	return (
		<>
			{[SPJ_ACTIONS.LAB_INVENTORY_CREATE].includes(operation) && (
				<AddBulkLabItems
					open={[SPJ_ACTIONS.LAB_INVENTORY_CREATE].includes(operation)}
					performingItemUpdate={operation === SPJ_ACTIONS.LAB_INVENTORY_UPDATE}
					onSubmit={() => {
						refresh();
					}}
					onClose={() => {
						setOperation(null);
					}}
				/>
			)}
			{[SPJ_ACTIONS.LAB_SKU_PRICE_UPDATE].includes(operation) && (
				<BulkUpdateSKUPrice
					open={[SPJ_ACTIONS.LAB_SKU_PRICE_UPDATE].includes(operation)}
					onSubmit={() => {
						refresh();
					}}
					onClose={() => {
						setOperation(null);
					}}
				/>
			)}
			<Popover
				open={Boolean(anchorElement)}
				anchorEl={anchorElement}
				onClose={() => {
					setAnchorElement(null);
				}}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<PopoverTitle>Select Bulk Operation</PopoverTitle>

				<PopoverBody>
					{options.map((option) => (
						<PopoverItem
							disabled={option.disabled}
							onClick={(e) => {
								setUploadInventoryFileAction(true, option.value, BULK_FILE_UPLOAD_STAGES.UPLOAD);
								setOperation(option.value);
								setAnchorElement(null);
							}}
						>
							{option.name}
						</PopoverItem>
					))}
				</PopoverBody>
			</Popover>

			{!(disableBulkUploadInventoryCreate && disableBulkUploadInventoryUpdate && disableBulkUploadPrice) && (
				<>
					{showUploadInventoryFile && (
						<Button
							secondary
							onClick={(e) => openInventoryFileUpload()}
						>
							<ProcessingIcon />
							Show Upload Progress
						</Button>
					)}
					{!showUploadInventoryFile && (
						<ButtonWithLoader
							loading={fetchingBatches}
							primary
							onClick={(e) => setAnchorElement(e.currentTarget)}
						>
							<AddIcon />
							Bulk Actions
						</ButtonWithLoader>
					)}
				</>
			)}
		</>
	);
};

const mapStatesToProps = (state) => {
	let supplierSellerPortalConfig = state.supplier.sellerPortalConfig || {};
	let userSellerPortalConfig = state.session.sellerPortalConfig || {};

	let disableBulkUploadInventoryCreate = supplierSellerPortalConfig.disable_bulk_upload_inventory_create || userSellerPortalConfig.disable_bulk_upload_inventory_create || false;
	let disableBulkUploadInventoryUpdate = supplierSellerPortalConfig.disable_bulk_upload_inventory_update || userSellerPortalConfig.disable_bulk_upload_inventory_update || false;
	let disableBulkUploadInventoryDelete = supplierSellerPortalConfig.disable_bulk_upload_inventory_delete || userSellerPortalConfig.disable_bulk_upload_inventory_delete || false;
	let disableBulkUploadPrice = supplierSellerPortalConfig.disable_bulk_upload_price || userSellerPortalConfig.disable_bulk_upload_price || false;

	return {
		supplier: state?.supplier?.supplier,
		isLabSeller: checkLabSeller(state?.session?.user_type),
		inventory: state.inventory.inventory,
		showUploadInventoryFile: (state?.inventory?.showUploadInventoryFile && state?.inventory?.uploadInventoryFileAction !== BULK_FILE_UPLOAD_STAGES.UPLOAD) || false,
		uploadInventoryFileType: state?.inventory?.uploadInventoryFileType || '',
		disableBulkUploadInventoryCreate,
		disableBulkUploadInventoryUpdate,
		disableBulkUploadInventoryDelete,
		disableBulkUploadPrice,
	};
};

const mapFunctionsToProps = { setUploadInventoryFileAction, setUploadInventoryFileBatch, fetchUploadInventoryFileBatch };

export default withRouter(connect(mapStatesToProps, mapFunctionsToProps)(BulkOperations));
